
import {
  defineComponent,
  ref,
  Ref,
  onMounted
} from 'vue';
import axios from 'axios';
import Skill from '@/models/Skill';

export default defineComponent({
  name: 'App',
  setup() {
    const lastUpdated = ref('');

    const skillOrder: Ref<Skill[]> = ref([]);

    const activeBonusSkill: Ref<Skill | null> = ref(null);

    const nextBonusSkillTimestamp = ref(0);

    const timeLeft = ref('');

    onMounted(async() => {
      const response = await axios.get('https://projectralph.com/bonus-skill/files/getskillorder.php');
      lastUpdated.value = response.data.updated || 'unknown';
      skillOrder.value = response.data.skillOrder;

      setActiveBonusSkill();

      updateTimeLeft();
      setInterval(updateTimeLeft, 1000);
    });

    function setActiveBonusSkill(): void {
      const epochTimestamp = Math.floor(Date.now() / 1000);

      const timedBonusSkillIndex = skillOrder.value.findIndex((skill: Skill) => !!skill.timestamp);
      const timedBonusSkill = skillOrder.value[timedBonusSkillIndex];

      if (timedBonusSkill.timestamp) {
        const epochDifference = epochTimestamp - timedBonusSkill.timestamp;
        const hourDifference = Math.floor(epochDifference / 3600);

        nextBonusSkillTimestamp.value = timedBonusSkill.timestamp + (Math.ceil(epochDifference / 3600) * 3600);

        let index = timedBonusSkillIndex + hourDifference;

        while (index >= skillOrder.value.length) {
          index -= skillOrder.value.length;
        }

        setSkillTimestamps(index);

        activeBonusSkill.value = skillOrder.value[index];
      } else {
        activeBonusSkill.value = null;
      }
    }

    function setSkillTimestamps(activeBonusSkillIndex: number): void {
      for (let i = 0; i < skillOrder.value.length; i++) {
        if (i !== activeBonusSkillIndex) {
          const activeBonusSkillTimestamp = nextBonusSkillTimestamp.value - 3600;
          const indexDifference = i < activeBonusSkillIndex ? skillOrder.value.length - activeBonusSkillIndex + i : i - activeBonusSkillIndex;
          skillOrder.value[i].nextTimestamp = activeBonusSkillTimestamp + (3600 * indexDifference);
        }
      }
    }

    function getLocalTime(epochTimestamp: number): string {
      return new Date(epochTimestamp * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    function updateTimeLeft(): void {
      const epochTimestamp = Math.floor(Date.now() / 1000);
      const secondsLeft = nextBonusSkillTimestamp.value - epochTimestamp;

      if (secondsLeft <= 0) {
        timeLeft.value = '00:00:00';

        setActiveBonusSkill();
      } else {
        const hours = Math.floor(secondsLeft / 3600);
        const minutes = Math.floor((secondsLeft % 3600) / 60);
        const seconds = Math.floor(secondsLeft % 60);

        timeLeft.value = `${formatValue(hours)}:${formatValue(minutes)}:${formatValue(seconds)}`;
      }
    }

    function formatValue(value: number): number | string {
      if (value < 10) {
        return `0${value}`;
      }

      return value;
    }

    return {
      activeBonusSkill,
      timeLeft,
      skillOrder,
      getLocalTime,
      lastUpdated
    };
  }
});
